const TEMPLATE_ONLY_ERROR = 'YCloud solo permite el envío de plantillas aprobadas en este flujo.'

const sanitizeTemplateParam = (value) => String(value || '').trim()

const createTemplateParamsBuilder = (requiredKeys) => (values = {}) =>
  requiredKeys.reduce((accumulator, key) => {
    accumulator[key] = sanitizeTemplateParam(values[key])
    return accumulator
  }, {})

const TEMPLATE_DEFINITIONS = {
  producer_new_order: {
    key: 'producer_new_order',
    label: 'Nuevo pedido para productor',
    params: ['producerName', 'storeName', 'commune', 'orderNumber', 'itemsText'],
    preview:
      'Hola Productor {{producerName}}, esperamos te encuentres bien😊.\n\nTenemos buenas noticias, ha llegado un pedido para ti y queremos saber si puedes prepararlo y despachar a la tienda {{storeName}} ubicada en {{commune}} 👋.\nNúmero de pedido: {{orderNumber}}.\n\n{{itemsText}}\n\n¿Puedes preparar el pedido?\n\n_Al confirmar, te enviaremos la nota de pedido al correo_',
  },
  producer_quotation: {
    key: 'producer_quotation',
    label: 'Cotización para productor',
    params: ['producerName', 'itemsText'],
    preview:
      'Hola Productor {{producerName}} 👋, un cliente de ComeS está cotizando:\n\n{{itemsText}}\n\n¿Tienes tú este producto o conoces a alguien que lo tenga? 😊',
  },
  store_order_confirmed: {
    key: 'store_order_confirmed',
    label: 'Pedido confirmado tienda',
    params: ['storeName', 'orderNumber'],
    preview:
      'Hola {{storeName}}, esperamos que te encuentres bien😊.\n\nQueremos informarte que tu pedido en ComeS N°. {{orderNumber}} se encuentra confirmado y está pronto a ser despachado por los productores.\n\nRecuerda que puedes rechazar el despacho si la caja no viene sellada o presenta daños por la manipulación de la empresa de transporte 🚚\n\nEquipo ComeS.',
  },
  purchase_survey: {
    key: 'purchase_survey',
    label: 'Encuesta post compra',
    params: ['storeName', 'surveyUrl'],
    preview:
      'Hola {{storeName}}\nSe ha completado tu primera compra en ComeS 😊\nConstantemente queremos mejorar y tu opinión es clave para lograrlo ❤️ por esto es muy importante que nos comentes cómo fue tu experiencia de compra.\nNo tomará más de 1 minuto.👇\nResponder aquí {{surveyUrl}}',
  },
  store_shipment_delivered: {
    key: 'store_shipment_delivered',
    label: 'Confirmación de envío entregado',
    params: ['storeName', 'producerName', 'orderNumber'],
    preview:
      'Hola {{storeName}}👋, nos enteramos que ya llegó el envío de {{producerName}}🚚\ncorrespondiente al pedido *N°{{orderNumber}}*\nPor favor cuéntanos ¿Llegó correctamente?',
    infoButtons: ['Sí, llegó correctamente', 'Tuve un problema'],
  },
  seguimiento_operativo: {
    key: 'seguimiento_operativo',
    label: 'Seguimiento operativo',
    params: ['name_txt', 'motivo_txt'],
    preview: 'Hola {{name_txt}} nos contactamos contigo porque {{motivo_txt}}\n\nSaludos.\n\nEquipo ComeS',
  },
}

export const WHATSAPP_TEMPLATES = {
  ...TEMPLATE_DEFINITIONS,
  PRODUCER_NEW_ORDER: TEMPLATE_DEFINITIONS.producer_new_order.key,
  PRODUCER_QUOTATION: TEMPLATE_DEFINITIONS.producer_quotation.key,
  STORE_ORDER_CONFIRMED: TEMPLATE_DEFINITIONS.store_order_confirmed.key,
  PURCHASE_SURVEY: TEMPLATE_DEFINITIONS.purchase_survey.key,
  STORE_SHIPMENT_DELIVERED: TEMPLATE_DEFINITIONS.store_shipment_delivered.key,
  SEGUIMIENTO_OPERATIVO: TEMPLATE_DEFINITIONS.seguimiento_operativo.key,
}

export const WHATSAPP_TEMPLATE_PARAM_LABELS = {
  producerName: 'Nombre productor',
  storeName: 'Nombre tienda',
  commune: 'Comuna',
  orderNumber: 'Número de pedido',
  itemsText: 'Productos/items',
  surveyUrl: 'URL encuesta',
  name_txt: 'Nombre',
  motivo_txt: 'Motivo',
}

const templateBuilders = {
  [WHATSAPP_TEMPLATES.PRODUCER_NEW_ORDER]: createTemplateParamsBuilder(TEMPLATE_DEFINITIONS.producer_new_order.params),
  [WHATSAPP_TEMPLATES.PRODUCER_QUOTATION]: createTemplateParamsBuilder(TEMPLATE_DEFINITIONS.producer_quotation.params),
  [WHATSAPP_TEMPLATES.STORE_ORDER_CONFIRMED]: createTemplateParamsBuilder(TEMPLATE_DEFINITIONS.store_order_confirmed.params),
  [WHATSAPP_TEMPLATES.PURCHASE_SURVEY]: createTemplateParamsBuilder(TEMPLATE_DEFINITIONS.purchase_survey.params),
  [WHATSAPP_TEMPLATES.STORE_SHIPMENT_DELIVERED]: createTemplateParamsBuilder(
    TEMPLATE_DEFINITIONS.store_shipment_delivered.params,
  ),
  [WHATSAPP_TEMPLATES.SEGUIMIENTO_OPERATIVO]: createTemplateParamsBuilder(
    TEMPLATE_DEFINITIONS.seguimiento_operativo.params,
  ),
}

export const createProducerNewOrderTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.PRODUCER_NEW_ORDER]
export const createProducerQuotationTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.PRODUCER_QUOTATION]
export const createStoreOrderConfirmedTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.STORE_ORDER_CONFIRMED]
export const createPurchaseSurveyTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.PURCHASE_SURVEY]
export const createStoreShipmentDeliveredTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.STORE_SHIPMENT_DELIVERED]
export const createSeguimientoOperativoTemplateParams = templateBuilders[WHATSAPP_TEMPLATES.SEGUIMIENTO_OPERATIVO]

export function createWhatsAppTemplatePayload({ to, template, params = {} } = {}) {
  if (!template || !templateBuilders[template]) {
    throw new Error(TEMPLATE_ONLY_ERROR)
  }

  return {
    to,
    template,
    params: templateBuilders[template](params),
  }
}

export function replaceTemplatePlaceholders(templateText = '', values = {}) {
  return templateText.replace(/{{\s*([a-zA-Z0-9_]+)\s*}}/g, (_, key) => {
    const value = values[key]
    return value && String(value).trim() ? String(value).trim() : `[${key}: pendiente]`
  })
}
